/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/discounts/discountcode
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyDiscountKey, ShopifyDiscountToShopKey, ShopifyShopKey } from "./keys";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion, ShopifyApiVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountKey,
  "2022-07": {
    name: "Shopify Discount",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id", skipGraphQLSelection: true } },
      },
      {
        name: "Discount ID",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountId",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
          },
        },
      },
      {
        name: "App Discount Type",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appDiscountType",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
            graphQLSelection: `
            app {
              id
            }
            appBridge {
              createPath
              detailsPath
            }
            appKey
            description
            discountClass
            functionId
            targetType
            title
            `,
          },
        },
      },
      {
        name: "Combines With",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "combinesWith",
            graphQLSelection: `
            orderDiscounts
            productDiscounts
            shippingDiscounts
            `,
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Discount Class",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountClass",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ORDER" }, { name: "PRODUCT" }, { name: "SHIPPING" }],
          allowMultiple: false,
          allowOther: true,
        },
      },
      {
        name: "Ends At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "endsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Starts At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "startsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Error History",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "errorHistory",
            graphQLSelection: `
            errorsFirstOccurredAt
            firstOccurredAt
            hasBeenSharedSinceLastError
            hasSharedRecentErrors
            `,
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "status",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ACTIVE" }, { name: "EXPIRED" }, { name: "SCHEDULED" }],
          allowOther: true,
          allowMultiple: false,
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "title",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Async Usage Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "asyncUsageCount",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Short Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shortSummary",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "summary",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Minimum Requirement",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "minimumRequirement",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            ... on DiscountMinimumQuantity {
              greaterThanOrEqualToQuantity
            }
            ... on DiscountMinimumSubtotal {
              greaterThanOrEqualToSubtotal {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Uses Per Order Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "usesPerOrderLimit",
            graphQLFragments: ["DiscountAutomaticBxgy", "DiscountCodeBxgy"],
          },
        },
      },
      {
        name: "Applies Once Per Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOncePerCustomer",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasTimelineComment",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Recurring Cycle Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "recurringCycleLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Shareable URLs",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shareableUrls",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            targetItemImage {
              id
            }
            targetType
            title
            url
            `,
          },
        },
      },
      {
        name: "Total Sales",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalSales",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Usage Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "usageLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Code Count",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codeCount",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Applies On One Time Purchase",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnOneTimePurchase",
            graphQLFragments: ["DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Destination Selection",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "destinationSelection",
            graphQLFragments: ["DiscountCodeFreeShipping"],
            graphQLSelection: `
            ... on DiscountCountries {
              countries
              includeRestOfWorld
            }
            ... on DiscountCountryAll {
              allCountries
            }
            `,
          },
        },
      },
      {
        name: "Maximum Shipping Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "maximumShippingPrice",
            graphQLFragments: ["DiscountCodeFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "custom", resource: "discountNodes" },
  },
  "2024-01": {
    name: "Shopify Discount",
    fields: [
      {
        name: "Combines With",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "combinesWith",
            graphQLSelection: `
            orderDiscounts
            productDiscounts
            shippingDiscounts
            `,
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Discount Class",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountClass",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ORDER" }, { name: "PRODUCT" }, { name: "SHIPPING" }],
          allowMultiple: false,
          allowOther: true,
        },
      },
      {
        name: "Ends At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "endsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Starts At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "startsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "status",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ACTIVE" }, { name: "EXPIRED" }, { name: "SCHEDULED" }],
          allowOther: true,
          allowMultiple: false,
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "title",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Async Usage Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "asyncUsageCount",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Short Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shortSummary",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "summary",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Minimum Requirement",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "minimumRequirement",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            ... on DiscountMinimumQuantity {
              greaterThanOrEqualToQuantity
            }
            ... on DiscountMinimumSubtotal {
              greaterThanOrEqualToSubtotal {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasTimelineComment",
            graphQLFragments: [
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Recurring Cycle Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "recurringCycleLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Total Sales",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalSales",
            graphQLFragments: [
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Applies On One Time Purchase",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnOneTimePurchase",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Destination Selection",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "destinationSelection",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            ... on DiscountCountries {
              countries
              includeRestOfWorld
            }
            ... on DiscountCountryAll {
              allCountries
            }
            `,
          },
        },
      },
      {
        name: "Maximum Shipping Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "maximumShippingPrice",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
    ],
    syncConfig: { type: "custom", resource: "discountNodes" },
  },
  "2024-04": {
    fields: [
      {
        name: "Code Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codeCount",
          },
        },
        isDeleted: true,
      },
      {
        name: "Codes Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codesCount",
            graphQLSelection: `
            count
            precision`,
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
    ],
  },
};

export const ShopifyDiscount = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
